import { useSessionContext } from '../contexts/SessionContext'

export const useFeatureAuth = (feature: string): boolean => {
  const { checkFeatureAuth } = useSessionContext()
  return checkFeatureAuth(feature)
}

export const useFeatureFlag = (flag: string): boolean => {
  const { user } = useSessionContext()
  return !!user?.feature_flags[flag]
}
